/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ods-vorgang-number',
  imports: [IconComponent],
  template: `<ods-icon [name]="type" fill="text" [label]="label" />
    <p>{{ text }}</p>`,
  host: { class: 'flex items-center gap-1.5 text-text' },
})
export class VorgangNumberComponent {
  @Input({ required: true }) text!: string;
  @Input({ required: true }) type!: 'aktenzeichen' | 'nummer';

  private readonly labelMap: Record<string, string> = { nummer: 'Nummer: ', aktenzeichen: 'Aktenzeichen: ' };

  get label(): string {
    return this.labelMap[this.type];
  }
}
